/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCliffJumping = createReactComponent("outline", "cliff-jumping", "IconCliffJumping", [["path", { "d": "M14 7a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M10.5 18l2.5 2l2 -2", "key": "svg-1" }], ["path", { "d": "M18 21l3 -3l-4 -2l-1 -5", "key": "svg-2" }], ["path", { "d": "M10.5 7.5l2 3l3.5 .5l3 -2l.5 -3", "key": "svg-3" }], ["path", { "d": "M4 21v-1l2 -3l.5 -2.5l1.5 -2.5l-1 -5l1 -3l-1 -1l-2 .5l-2 -.5", "key": "svg-4" }]]);

export { IconCliffJumping as default };
//# sourceMappingURL=IconCliffJumping.mjs.map
